import React from 'react'
import { Pie, PieChart } from 'recharts';
import SunBurstChart from './SunBurstChart';

export default function Discover() {

  const datas = [
    {
      title: "Failure of supply chain due to geopolitical issues",
      location: "Europe",
      risk: 2,
    },
    {
      title:
        "Business disruption due to issues such as equipment failure or system malfunctions",
      location: "Asia",
      risk: 0,
    },
    {
      title:
        "Negative publicity or damage to a company's reputation due to factors such as product recalls or ethical lapses",
      location: "USA, NY",
      risk: 1,
    },
    {
      title:
        "Financial loss due to fraudulent activities such as embezzlement, identity theft, or accounting fraud",
      location: "USA, Europe, Asia",
      risk: 2,
    },
    {
      title:
        "Data breaches, hacking, or other cyberattacks that can compromise sensitive information",
      location: "USA, NY",
      risk: 2,
    },
    {
      title:
        "Business disruption or loss due to technological failures, cyberattacks, or obsolete technology",
      location: "Global",
      risk: 0,
    },
    {
      title: "Delays, cost overruns, or failure to achieve project objectives",
      location: "USA, NY",
      risk: 2,
    },
    {
      title:
        "Data breaches, hacking, or other cyberattacks that can compromise sensitive information",
      location: "Asia",
      risk: 1,
    },
    {
      title:
        "Financial or legal penalties due to failure to comply with internal policies or external regulations",
      location: "USA, NY",
      risk: 2,
    },
    {
      title:
        "Data breaches, hacking, or other cyberattacks that can compromise sensitive information",
      location: "USA, NY",
      risk: 1,
    },
  ];
const data01 = [
  {
    name: "Group A",
    value: 400,
  },
  {
    name: "Group B",
    value: 300,
  },
  {
    name: "Group C",
    value: 300,
  },
  {
    name: "Group D",
    value: 200,
  },
  {
    name: "Group E",
    value: 278,
  },
  {
    name: "Group F",
    value: 189,
  },
];
const data02 = [
  {
    name: "Group A",
    value: 2400,
  },
  {
    name: "Group B",
    value: 4567,
  },
  {
    name: "Group C",
    value: 1398,
  },
  {
    name: "Group D",
    value: 9800,
  },
  {
    name: "Group E",
    value: 3908,
  },
  {
    name: "Group F",
    value: 4800,
  },
];
    
    const riskStatus = (risk: number) => {
      let dotColor = "bg-white";
      let riskLabel = "Medium decreasing";
      if (risk === 2) {
        dotColor = "bg-error-600";
        riskLabel = "High increasing";
      } else if (risk === 1) {
        dotColor = "bg-indigo-600";
        riskLabel = "Medium increasing";
      }
      return (
        <>
          <span className={"dot mr-2 " + dotColor}></span>
          riskLabel
        </>
      );
    };

  return (
    <div className="row">
      <div className="col-6">
        <h5 className="fw-300">Risk Universe</h5>
        <h1 className="fw-300">Risk Universe</h1>
        <p className="text-gray-400 fw-300">
          Your risk universe is a collection of all your risks, controls,
          processes, and incidents. All elements come together to create the
          overall score. Use the filters to fine tune or click on the chart to
          explore.
        </p>

        <ul className="time-line">
          {datas.map((data, i) => (
            <li className="d-flex justify-content-between" key={i}>
              <div className="d-inline-flex align-items-center">
                <div className="ml-3">
                  <h6 className="text-gray-50 fw-400">{data.title}</h6>
                  <span className="text-gray-400 fw-300">
                    <small className="text-uppercase text-7s">
                      {/* data.risk */}
                      {riskStatus(data.risk)}
                    </small>
                    <span className="text-gray-500">
                      <span className="mh-2">|</span>
                      <i className="icon-map-pin mr-2 text-2c"></i>
                      {data.location}
                    </span>
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-6" style={{ margin: 'auto'}}>
        {/* <PieChart width={896} height={896}>
          <Pie
            data={data01}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={275}
            outerRadius={345}
            fill="#3A3A4A"
          />
          <Pie
            data={data02}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={350}
            outerRadius={400}
            fill="#1A1A24"
            label
          />
        </PieChart> */}
        <SunBurstChart />
      </div>
    </div>
  );
}
